import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Select from 'react-select'
import CsvDownloader from 'react-csv-downloader';

import Header from '../../components/header/Header';
import OrganisationName from '../../components/shared/OrganisationName';
import SetTitle from '../../components/shared/SetTitle';

import { optionalParam, buildParams, formatDate, arrayParamBuilder, debounce } from '../../utilities/Generic'

import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { request, handleRequestErrors } from '../../helpers/Requests'

class SalesSummary extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
    this.handleMultiSelectChange = this.handleMultiSelectChange.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.debouncedUpdateSale = debounce(this.handleSaleUpdate.bind(this), 500);
  }

  state = {
    date_from: null,
    date_to: null,
    location: "",
    role_id: "",
    host_person_ids: [],
    tag_ids: [],

    refresh_date_from: formatDate(new Date(), 0),
    refresh_date_to: formatDate(new Date(), 0),
    refresh_location: "",
    refresh_role_id: "",
    refresh_host_person_ids: [],
    refresh_tag_ids: [],

    locations: [],
    roles: [],
    tags: [],

    sales: [],
    host_people_with_hours: [],

    locationsLoaded: false,
    rolesLoaded: false,
    tagsLoaded: false,
    sales_summary_loaded: false,
    unauthorized: "",
    error: ""
  };
  
  fetchData() {
    const params = `sales_summary[date_from]=${this.state.date_from}&sales_summary[date_to]=${this.state.date_to}&sales_summary[location]=${this.state.location}&sales_summary[role_id]=${this.state.role_id}${arrayParamBuilder(null, "tag_ids", this.state.tag_ids)}`;

    request('GET', `/v1/a/exports/sales_summary?${params}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => this.setState({ sales: data.planned_events, host_people_with_hours: data.host_people_with_hours, sales_summary_loaded: true }))
      .catch(error => handleRequestErrors(this, error, {sales_summary_loaded: true}))
  }

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    let url = {
      date_from: this.state.date_from,
      date_to: this.state.date_to,
      location: this.state.location,
      role_id: this.state.role_id,
      tag_ids: this.state.tag_ids,
      host_person_ids: this.state.host_person_ids,
    }

    url[name] = value

    if (name !== "host_person_ids") {
      url.host_person_ids = []
    }

    const params = buildParams(
      `from=${url.date_from}&to=${url.date_to}`,
      optionalParam("location", url.location),
      optionalParam("role_id", url.role_id),
      optionalParam("tag_ids", url.tag_ids),
      optionalParam("host_person_ids", url.host_person_ids),
    )
    
    this.props.history.push(`/exports/sales-summary?${params}`);
  }

  handleMultiCheckbox(event) {
    const name = parseInt(event.target.name);
    const value = event.target.checked;

    const host_person_ids = [...this.state.host_person_ids];

    if (value === true) {
      if (!host_person_ids.includes(name)) {
        host_person_ids.push(name)
      }
    }
    else if (value === false) {
      if (host_person_ids.includes(name)) {
        const index = host_person_ids.indexOf(name)
        host_person_ids.splice(index, 1)
      }
    }

    const fakeEvent = {}
    fakeEvent.target = {}
    fakeEvent.target.name = "host_person_ids"
    fakeEvent.target.value = host_person_ids

    this.handleChange(fakeEvent)
  }

  handleMultiSelectChange(data, meta) {
    const fakeEvent = {}
    fakeEvent.target = {}
    fakeEvent.target.name = meta.name
    fakeEvent.target.value = data.map(option => option.value);

    this.handleChange(fakeEvent)
  }

  handleAmountChange(event) {
    const paymentMethod = event.target.name.split("_")[0];
    const id = parseInt(event.target.name.split("_")[1]);
    let value = event.target.value;

    let sales = [...this.state.sales];
    sales.map(sale => {
      if (sale.id === id) {
        sale[`paid_with_${paymentMethod}`] = `£${value}`;
      }
      return sale
    })

    this.setState({sales: sales})

    this.debouncedUpdateSale(id, paymentMethod, value)
  }

  handleSaleUpdate(id, paymentMethod, value) {
    const json = { planned_event: { [`paid_with_${paymentMethod}`]: value }}

    request("PUT", `/v1/a/planned_events/${id}`, JSON.stringify(json), () => { this.setState({ unauthorized: true }) })
      .then(data => {
        let sales = [...this.state.sales];
        sales.map(sale => {
          if (sale.id === data.id) {
            sale.total_amount_paid = data.total_amount_paid;
          }
          return sale
        })

        this.setState({sales: sales})
      })
      .catch(error => handleRequestErrors(this, error))
  }

  render() {
    const { sales, locationsLoaded, unauthorized, error, rolesLoaded, tagsLoaded, sales_summary_loaded } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (locationsLoaded === false || rolesLoaded === false || tagsLoaded === false) {
      return (
        <div>
          <SetTitle title={"Export Sales Summary | Exports"} />
          <Header />

          <div className="main-page">
            <h2 className="page-title">Export Revenue</h2>
            <OrganisationName />

            <p>Loading ...</p>
          </div>
        </div>
      )
    }

    return (
      <div>
        <SetTitle title={"Sales Summary | Exports"} />
        <Header />

        <div className="main-page">
          <h2 className="page-title">Sales Summary</h2>
          <OrganisationName />

          {this.renderMetricsSection()}

          {this.renderFilters()}

          {sales_summary_loaded ? (
            <div className="widgets">
              {this.renderDownloadCSV()}
              {this.renderSales()}

              {sales.length === 0 && (
                <p>No data found for those filters.</p>
              )}
            </div>
          ) : (
            <p>Loading ...</p>
          )}
        </div>
      </div>
    );
  }

  renderFilters () {
    const { date_from, date_to, locations, location, role_id, roles, tag_ids, tags } = this.state;

    const selectOptions = tags.map(tag => ({ value: tag.id, label: tag.name }))
    const selectedTags = selectOptions.filter(option => tag_ids.includes(option.value))

    return (
      <div className="export-selection">
        <div className="selection-block">
          <label className="column">Date from:</label>
          <input className="column" type="date" name="date_from" value={date_from} onChange={this.handleChange} />
        </div>

        <div className="selection-block">
          <label className="column">Date to:</label>
          <input className="column" type="date" name="date_to" value={date_to} onChange={this.handleChange} />
        </div>

        <div className="selection-block">
          <label className="column">Location:</label>
          <select name="location" value={location} onChange={this.handleChange} data-testid="select-locations">
            <option value="">All</option>
            {locations.map((location) => (
              <option value={location.id} key={location.id}>{location.name}</option>
            ))}
          </select>
        </div>

        <div className="selection-block">
          <label className="column">Roles:</label>
          <select name="role_id" value={role_id} onChange={this.handleChange}>
            <option value="">All</option>
            {roles.map((role) => (
              <option value={role.id} key={role.id}>{role.name}</option>
            ))}               
          </select>
        </div>

        <div className="selection-block">
          <label className="column">Filter by Tags:</label>
          <Select name="tag_ids" onChange={this.handleMultiSelectChange} options={selectOptions} value={selectedTags} isMulti={true} unstyled={true} className="react-select" classNamePrefix="react-select" placeholder={"All"} />
        </div>
        <br/>
        {this.renderHostPeople()}
      </div>
    )
  }

  renderHostPeople() {
    const host_people = this.state.host_people_with_hours;

    if (host_people.length === 0) {
      return
    }

    if (host_people.length < 10) {
      return (
        <div className="selection-block small-bottom-margin">
          Filter by Staff:
          {host_people.map((host_person) => (
            <div className="selection-block right-label" key={`host_person_${host_person.id}`}>
              <input className="clickable" type="checkbox" id={host_person.id} name={host_person.id} checked={this.state.host_person_ids.includes(host_person.id)} onChange={this.handleMultiCheckbox} />
              <label className="clickable" htmlFor={host_person.id}>{host_person.name}</label>
            </div>
          ))}
        </div>
      )
    }

    const selectOptions = host_people.map(host_person => ({ value: host_person.id, label: host_person.name }))
    const selectedTags = selectOptions.filter(option => this.state.host_person_ids.includes(option.value))
    return (
      <div className="selection-block small-bottom-margin">
        <label className="column">Filter by Staff:</label>
        <Select onChange={this.handleMultiSelectChange} options={selectOptions} value={selectedTags} isMulti={true} unstyled={true} className="react-select" classNamePrefix="react-select" placeholder={"All"} />
      </div>
    )
  }

  renderDownloadCSV() {
    const { sales, host_person_ids, date_from, date_to } = this.state;

    const filteredSales = host_person_ids.length === 0 ? sales : sales.filter(sale => sale.hosts.some(host => host_person_ids.includes(host.id)))

    const filename = `sales-summary-export-${date_from}-to-${date_to}.csv`
    let formatted_sales = [];

    filteredSales.forEach(sale => {
      const formatedSale = {
        date: sale.date,
        time: sale.time,
        staff: sale.hosts.map(host => host.name).join(', '),
        clients: sale.clients.map(client => client.name).join(', '),
        service: sale.service_name,
        price: sale.service_price,
        deposit: sale.deposit,
        paid_with_card: sale.paid_with_card,
        paid_with_cash: sale.paid_with_cash,
        total_paid: sale.total_amount_paid
      }
      formatted_sales.push(formatedSale);
    })

    let columns = [
      { displayname: "Date", id: "date" },
      { displayname: "Time", id: "time" },
      { displayname: "Staff", id: "staff" },
      { displayname: "Clients", id: "clients" },
      { displayname: "Service", id: "service" },
      { displayname: "Price", id: "price" },
      { displayname: "Deposit", id: "deposit" },
      { displayname: "Paid with Card", id: "paid_with_card" },
      { displayname: "Paid with Cash", id: "paid_with_cash" },
      { displayname: "Total Paid", id: "total_paid" },
    ];

    return (
      <CsvDownloader datas={formatted_sales} columns={columns} filename={filename} className="edit-button download-csv relative-csv right" wrapColumnChar='"'>
        <div>
          <FontAwesomeIcon icon={faFileDownload} />
          <h4>Download CSV</h4>
        </div>
      </CsvDownloader>
    )
  }

  renderSales() {
    const { sales, host_person_ids } = this.state;

    const filteredSales = host_person_ids.length === 0 ? sales : sales.filter(sale => sale.hosts.some(host => host_person_ids.includes(host.id)))
    return (
      <table className="table big-table top-padding" data-testid="table">
        <thead>
          <tr className="tr heading">
            <th className="th">Date</th>
            <th className="th">Time</th>
            <th className="th">Staff</th>
            <th className="th">Clients</th>
            <th className="th">Service</th>
            <th className="th">Price</th>
            <th className="th">Deposit</th>
            <th className="th">Paid with Card</th>
            <th className="th">Paid with Cash</th>
            <th className="th">Total Paid</th>
          </tr>
        </thead>
        <tbody>
          {filteredSales.map((sale) => (
              this.renderSaleRow(sale)
          ))}
        </tbody>
      </table>
    )
  }

  renderSaleRow(sale) {
    const paid_with_card = sale.paid_with_card.replace(/[£,]/g, '');
    const paid_with_cash = sale.paid_with_cash.replace(/[£,]/g, '');

    return (
      <tr className="tr" key={sale.id}>
        <td className="td">{sale.date}</td>
        <td className="td">{sale.time}</td>
        <td className="td">{sale.hosts.map(host => host.name).join(', ')}</td>
        <td className="td">{sale.clients.map(client => client.name).join(', ')}</td>
        <td className="td">{sale.service_name}</td>
        <td className="td">{sale.service_price}</td>
        <td className="td">{sale.deposit}</td>
        <td className="td">
          £ <input name={`card_${sale.id}`} className="export-table-input" type="number" min="0" step="0.01" onChange={this.handleAmountChange} value={paid_with_card} />
        </td>
        <td className="td">
          £ <input name={`cash_${sale.id}`} className="export-table-input" type="number" min="0" step="0.01" onChange={this.handleAmountChange} value={paid_with_cash} />
        </td>
        <td className="td">{sale.total_amount_paid}</td>
      </tr>
    )
  }

  calculateMetrics() {
    const { sales, host_people_with_hours, host_person_ids } = this.state;

    const filteredSales = host_person_ids.length === 0 ? sales : sales.filter(sale => sale.hosts.some(host => host_person_ids.includes(host.id)))
    const filteredHostPeople = host_person_ids.length === 0 ? host_people_with_hours : host_people_with_hours.filter(host => host_person_ids.includes(host.id))

    let total_collected = 0;
    let service_collected = 0;
    let total_cash = 0;
    let total_card = 0;
    let total_hours_rota = 0;
    let total_minutes_appointments = 0;

    filteredSales.forEach(sale => {
      total_collected += parseFloat(sale.total_amount_paid.replace(/[£,]/g, ''));
      service_collected += parseFloat(sale.service_price.replace(/[£,]/g, ''));
      total_cash += parseFloat(sale.paid_with_cash.replace(/[£,]/g, '') || 0);
      total_card += parseFloat(sale.paid_with_card.replace(/[£,]/g, '') || 0);
      total_minutes_appointments += sale.service_working_minutes
    })

    const total_hours_appointments = total_minutes_appointments / 60.0;

    filteredHostPeople.forEach(host => {
      total_hours_rota += host.hours;
    })

    return {
      total_collected: total_collected.toFixed(2),
      service_collected: service_collected.toFixed(2),
      total_cash: total_cash.toFixed(2),
      total_card: total_card.toFixed(2),
      total_hours_rota: total_hours_rota.toFixed(2),
      total_hours_appointments: total_hours_appointments.toFixed(2)
    };
  }

  renderMetricsSection() {
    const { total_collected, service_collected, total_cash, total_card, total_hours_rota, total_hours_appointments } = this.calculateMetrics();

    return (
      <div className="metric-cards-container">
        <div className="metric-card">
          <div className="card-title">Total collected</div>
          <div className="card-content">
            <div className="metric-value">£{total_collected}</div>
          </div>
        </div>

        <div className="metric-card">
          <div className="card-title">Cash vs Card</div>
          <div className="card-content split-container">
            <div className="metric-value">£{total_cash}</div>
            <div className="divider"></div>
            <div className="metric-value">£{total_card}</div>
          </div>
        </div>

        <div className="metric-card">
          <div className="card-title">Service vs Collected</div>
          <div className="card-content split-container">
            <div className="metric-value">£{service_collected}</div>
            <div className="divider"></div>
            <div className="metric-value">£{total_collected}</div>
          </div>
        </div>

        <div className="metric-card">
          <div className="card-title">Hours Rota'd vs Hours of Appointments</div>
          <div className="card-content split-container">
            <div className="metric-value">{total_hours_rota}</div>
            <div className="divider"></div>
            <div className="metric-value">{total_hours_appointments}</div>
          </div>
        </div>
      </div>
    )
  }

  syncParamsAndState() {
    const params = new URLSearchParams(this.props.location.search);

    const date_from = params.get('from') || this.state.refresh_date_from;
    const date_to = params.get('to') || this.state.refresh_date_to;
    const location = params.get('location') || this.state.refresh_location;
    const role_id = params.get('role_id') || this.state.refresh_role_id;
    const tag_ids = params.get('tag_ids')?.split(",").map(id => parseInt(id)) || this.state.refresh_tag_ids;
    const host_person_ids = params.get('host_person_ids')?.split(",").map(id => parseInt(id)) || this.state.refresh_host_person_ids;

    const builtParams = buildParams(
      `from=${date_from}&to=${date_to}`,
      optionalParam("location", location),
      optionalParam("role_id", role_id),
      optionalParam("tag_ids", tag_ids),
      optionalParam("host_person_ids", host_person_ids)
    );

    const currentParams = this.props.location.search.replace("?", "");

    if (currentParams !== builtParams) {
      this.props.history.replace(`/exports/sales-summary?${builtParams}`);
      return;
    }

    this.setState({
      date_from: date_from,
      date_to: date_to,
      location: location,
      role_id: role_id,
      tag_ids: tag_ids,
      host_person_ids: host_person_ids,
      sales_summary_loaded: false
    }, () => {
      this.fetchData();
    });
  }

  componentDidMount() {
    this.syncParamsAndState();

    // normal API fetching stuff
    request('GET', `/v1/a/locations/names_and_ids`, null, () => {this.setState({ unauthorized: true })})
      .then(data => this.setState({ locations: data, locationsLoaded: true }))
      .catch(error => handleRequestErrors(this, error, { locationsLoaded: true }))

    request('GET', `/v1/a/roles/names_and_ids`, null, () => {this.setState({ unauthorized: true })})
      .then(data => this.setState({ roles: data, rolesLoaded: true }))
      .catch(error => handleRequestErrors(this, error, { rolesLoaded: true }))

    request('GET', `/v1/a/tags/names_and_ids`, null, () => this.setState({ unauthorized: true }))
      .then(data => this.setState({ tags: data, tagsLoaded: true }))
      .catch(error => handleRequestErrors(this, error, { tagsLoaded: true }))
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      this.syncParamsAndState();
    }
  }
}

export default SalesSummary;
